import React from 'react';
import { Card } from 'antd';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

// Sample Data
const sampleCategoryPercentage = [
  { name: 'Hardware Failure', value: 30 },
  { name: 'Software Crash', value: 20 },
  { name: 'Network Outage', value: 15 },
  { name: 'Tech Support', value: 25 },
  { name: 'Malware Infection', value: 10 },
];

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#FF6699"];

const TicketsByCategory: React.FC = () => {
  return (
  <Card title="Tickets by Category in Percentage">
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={sampleCategoryPercentage}
          dataKey="value"
          nameKey="name"
          outerRadius={120}
          fill="#82ca9d"
        >
          {sampleCategoryPercentage.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  </Card>
  );
};

export default TicketsByCategory;